import React from 'react';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class PopupFooter extends React.PureComponent {
  handleClick = isApply => () => {
    const { confirm } = this.props;

    confirm(isApply);
  };

  render() {
    const {
      enabledCancel,
      enabledApply,
      titleYes,
      titleNo,
      fontSize,
    } = this.props;
    const className =
      fontSize === 'Small'
        ? 'mr-5 d-flex align-items-center justify-content-center'
        : 'mr-5 d-flex align-items-end justify-content-center';
    return (
      <div className="popup-button mt-5 text-left d-flex">
        {enabledApply && (
          <button
            className={`btn btn-primary ${className}`}
            onClick={this.handleClick(true)}
          >
            <Translate value={titleYes} />
          </button>
        )}
        {enabledCancel && (
          <button
            className={`btn btn-cancel ${className}`}
            onClick={this.handleClick(false)}
          >
            <Translate value={titleNo} />
          </button>
        )}
      </div>
    );
  }
}

PopupFooter.propTypes = {
  enabledCancel: PropTypes.bool.isRequired,
  enabledApply: PropTypes.bool.isRequired,
  confirm: PropTypes.func.isRequired,
  titleYes: PropTypes.string,
  titleNo: PropTypes.string,
};

PopupFooter.defaultProps = {
  enabledCancel: true,
  enabledApply: true,
  confirm: () => {},
  titleYes: 'common.YES',
  titleNo: 'common.CANCEL',
};

const mapStateToProps = ({ fontSize }) => ({ fontSize });

export default connect(mapStateToProps)(PopupFooter);
